import { EsecutoreModalComponent } from './../esecutore-modal/esecutore-modal.component'
import { EsecutoreService } from './../services/esecutore.service'
import { IEsecutore } from './../interfaces/IEsecutore'
import { Component, OnInit, ViewChild } from '@angular/core'
import * as Enum from '../utils/enums'
import { TranslateService } from '@ngx-translate/core'
import { DialogService } from 'primeng/api'
import { AlertUtil } from '../utils/alert-util'
import * as Constants from '../utils/constants'
import { finalize } from 'rxjs/operators'
import { RequestBuilder } from '../classes/request-builder'
import { Loading } from '../utils/loading'
import { DataTableComponent } from '../data-table/data-table.component'
import { IRichiesta } from '../interfaces/IRichiesta'
import { IDocumento } from '../interfaces/IDocumento'
import { DocumentiService } from '../services/documenti.service'
import { IStoricoRisposte } from '../interfaces/IStoricoRisposte'
import { DocumentoModalComponent } from '../documento-modal/documento-modal.component'
import { RichiestaService } from '../services/richiesta.service'
import { StoricoModuloService } from '../services/storicomodulo.service'
import { Util } from '../utils/util';

@Component({
  selector: 'app-esecutori',
  templateUrl: './esecutori.component.html',
  styleUrls: ['./esecutori.component.css'],
})
export class EsecutoriComponent implements OnInit {
  esecutori: IEsecutore[] // table data source
  rowSelected: boolean = false //determines whether one commessa row has been clicked
  esecutore: IEsecutore

  isAggiudicatario: boolean

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html

  esecutoreSelected: IEsecutore // esecutore selected from table
  richiestaSelected: IRichiesta // richiesta selected from table
  documentoSelected: IDocumento // documento selected from table

  richieste: IRichiesta[] // richieste table data source
  documenti: IDocumento[] // documenti table data source

  richiestaTableSelectedItem: any //richiesta selected item

  @ViewChild('dtDocumenti') dtDocumenti: DataTableComponent
  @ViewChild('dtRichieste') dtRichieste: DataTableComponent

  constructor(
    private esecutoreService: EsecutoreService,
    private richiestaService: RichiestaService,
    private storicoModuloService: StoricoModuloService,
    private translate: TranslateService,
    private documentiService: DocumentiService,
    private dialogService: DialogService,
    private alertUtil: AlertUtil
  ) { }

  ngOnInit() {
    this.isAggiudicatario = false
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO) {
      this.isAggiudicatario = true
    }
    setTimeout(() => {
      this.getAllEsecutori()
    }, 0)
  }

  /**
   * get all esecutori
   */
  getAllEsecutori() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.esecutoreService
      .fetchEsecutori(reqBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false
        })
      )
      .subscribe(
        (response) => {
          if (response.data) {
            this.esecutori = response.data
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log('ERROR: ' + response.error.Stack)
          } else {
            this.alertUtil.showErrorAlert('LBL_SERVER_ERROR_GENERIC', {
              error: response.Message,
            })
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0'
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
  }

  onCreateEsecutore() {
    this.esecutore = null
    this.openEsecutoreModal(false)
  }

  onUpdateEsecutore(esecutoreForUpdate: IEsecutore) {
    this.esecutore = esecutoreForUpdate
    this.openEsecutoreModal(true)
  }

  /**
   * open new esecutore modal
   */
  openEsecutoreModal(isUpdate: boolean) {
    let modalTitle = 'LBL_NEW_ESECUTORE'
    if (isUpdate) {
      modalTitle = 'LBL_UPDATE_ESECUTORE'
    }
    //get header translation
    this.translate.get(modalTitle).subscribe((res) => {
      let esecutore = this.esecutore
      //open esecutori modal
      let esecutoreModal = this.dialogService.open(EsecutoreModalComponent, {
        data: {
          esecutore: esecutore,
          fromFiliera: false,
        },
        header: res,
        width: '50%',
      })

      // refresh esecutori when modal is closed and newEsecutore is created
      esecutoreModal.onClose.subscribe((esecutoreObj) => {
        if (esecutoreObj) {
          this.getAllEsecutori()
        }
      })
    })
  }

  /**
   * delete object confirmation
   */
  openDeleteDialog(esecutoreObj: IEsecutore) {
    this.alertUtil.showConfirmationAlert(
      'LBL_CONFIRM_ESECUTORE_DELETE',
      null,
      null,
      null,
      null,
      () => {
        this.deleteEsecutore(esecutoreObj)
      }
    )
  }

  deleteEsecutore(esecutoreObj: IEsecutore) {
    Loading.isLoading = true
    let payload = {
      IdAzienda: esecutoreObj.Id,
    }
    let reqBuilder = new RequestBuilder(payload)
    this.esecutoreService
      .deleteEsecutore(reqBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false
        })
      )
      .subscribe(
        (response) => {
          if (response.data) {
            //MESSAGGIO OK
            this.alertUtil.showAlert(
              'LBL_DELETE_ESECUTORE_SUCCESS',
              null,
              null,
              null,
              () => {
                this.getAllEsecutori()
              }
            )
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log('ERROR: ' + response.error.Stack)
          } else {
            this.alertUtil.showErrorAlert('LBL_SERVER_ERROR_GENERIC', {
              error: response.Message,
            })
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0'
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
  }

  /**
   * callback fired when one esecutore row is selected
   * @param esecutore
   */
  onEsecutoreRowSelected(esecutore: IEsecutore) {
    this.esecutoreSelected = esecutore
    this.onRichiestaRowUnselected();
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({ EsecutoreId: esecutore.Id })
    this.esecutoreService
      .getRichiesteApprovate(requestBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false
        })
      )
      .subscribe(
        (response) => {
          if (response.data) {
            //Resets sort, filter and paginator state.
            this.dtRichieste.resetTable()
            this.richieste = response.data
            this.richieste.forEach((richiesta: IRichiesta) => {
              richiesta.Id = richiesta.IdRichiesta
            })
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log('ERROR: ' + response.error.Stack)
          } else {
            this.alertUtil.showErrorAlert('LBL_SERVER_ERROR_GENERIC', {
              error: response.Message,
            })
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0'
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
  }

  /**
   * callback fired when one esecutore row is unselected
   */
  onEsecutoreRowUnselected() {
    this.esecutoreSelected = null
    this.richiestaSelected = null
    this.documentoSelected = null
  }

  /**
   * callback fired when one esecutore row is selected
   * @param esecutore
   */
  onRichiestaRowSelected(richiesta: IRichiesta) {
    this.richiestaSelected = richiesta
    this.callDocumentiForRichiesta(this.richiestaSelected);
  }

  private callDocumentiForRichiesta(richiesta: IRichiesta) {
    Loading.isLoading = true;
    let documentoRequest = {
      idCommessa: '%',
      idCantiere: '%',
      idRichiesta: richiesta.IdRichiesta,
      idAzienda: this.esecutoreSelected.Id,
      Text: '',
      RichiestePerEsecutore: richiesta.RichiestePerEsecutore
    };
    let requestBuilder = new RequestBuilder(documentoRequest);
    this.documentiService
      .fullTextSearch(requestBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          if (response.data) {
            //Resets sort, filter and paginator state.
            this.dtDocumenti.resetTable();
            this.documenti = response.data;
          } else if (response.error) {
            this.richiestaSelected = null
            let errorKey = 'LBL_ERROR_' + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log('ERROR: ' + response.error.Stack);
          } else {
            this.richiestaSelected = null
            this.alertUtil.showErrorAlert('LBL_SERVER_ERROR_GENERIC', {
              error: response.Message,
            });
          }
        },
        (error) => {
          this.richiestaSelected = null
          let errorKey = 'LBL_HTTP_ERROR_0';
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }

  /**
   * callback fired when one esecutore row is unselected
   */
  onRichiestaRowUnselected() {
    this.richiestaSelected = null
    this.documentoSelected = null
  }

  onDocumentoRowSelected(documento: IDocumento) {
    this.rowSelected = true
    this.documentoSelected = documento

    this.callStoricoModuloFetchSingle(0)
  }

  /**
   * call storicoModulo fetch single
   */
  callStoricoModuloFetchSingle(versioneDoc: number) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      Id: this.documentoSelected.Id,
      Version: versioneDoc > 0 ? versioneDoc : null,
    })
    this.storicoModuloService
      .storicoModuloFetchSingle(requestBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false
        })
      )
      .subscribe(
        (response) => {
          if (response.data) {
            this.documentoSelected = response.data
            this.createCustomResponse()
            if (this.rowSelected) {
              this.checkUserRoleAndOpenModal(versioneDoc > 0 ? versioneDoc : -1)
            }
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            console.log('ERROR: ' + response.error.Stack)
          } else {
            this.alertUtil.showErrorAlert('LBL_SERVER_ERROR_GENERIC', {
              error: response.Message,
            })
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0'
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
  }

  /**
   * read documento Selected and set Risposta Custom for all questions
   */
  createCustomResponse() {
    let storicoRisposte = this.documentoSelected.StoricoRisposte //get storico risposte array
    let matrDomande = this.documentoSelected.MatriceModulo.MatriceDomande //get matrice domande array
    if (matrDomande) {
      for (let i = 0; i < matrDomande.length; i++) {
        // iterate matrice domande
        let matriceDomanda = matrDomande[i]
        if (storicoRisposte) {
          for (let y = 0; y < storicoRisposte.length; y++) {
            // iterate storico risposte
            let storicoRisp = storicoRisposte[y]
            if (storicoRisp.Domanda_Id == matriceDomanda.Id) {
              // if answer for this question set rispostaCustom to matrice domanda
              matriceDomanda.RispostaCustom = storicoRisp
              break
            }
          }
          if (!matriceDomanda.RispostaCustom) {
            // if matrice domanda has no risposta custom set empty risposta
            let storicoEmpty: IStoricoRisposte = {
              Domanda_Id: matriceDomanda.Id,
              Valore: null,
              Placeholder: null,
              Valido: null,
            }
            matriceDomanda.RispostaCustom = storicoEmpty
          }
        }
      }
    }
  }

  /**
   * check user role and open modal
   */
  private checkUserRoleAndOpenModal(versioneDoc: number) {
    this.openDocumentoModal(this.documentoSelected)
  }

  /**
   * open documento modal
   * @param documento
   */
  openDocumentoModal(documento: IDocumento) {
    let documentoModal = this.dialogService.open(DocumentoModalComponent, {
      data: {
        documento,
        richiesta: documento.Richiesta,
        fromFullTextSearch: true,
        fromEsecutore: true
      },
      header: documento.Nome,
      width: '80%',
    })
    documentoModal.onClose.subscribe((documentoObj) => {
      if (documentoObj) {
        //force refresh
        this.rowSelected = false
        this.callStoricoModuloFetchSingle(0)
      }
    })
  }

  /**
   * callback fired when one documento row is unselected
   */
  onDocumentoRowUnselected() {
    this.documentoSelected = null
  }


  /**
   * Click on button to show PDF
   * @param documento 
   */
  onClickShowPDF(documento: IDocumento) {

    Loading.isLoading = true

    let documentoCloned: IDocumento = {
      Id: documento.Id,
      Nome: documento.Nome,
      Descrizione: documento.Descrizione,
      Tipologia: documento.Tipologia,
      Data_scadenza: documento.Data_scadenza,
      Documento: documento.Documento,
      DocumentoCreato: documento.DocumentoCreato,
      Autore: documento.Autore,
      Versione: -1
    }

    let reqBuilder = new RequestBuilder(documentoCloned)
    this.documentiService.showPDF(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        //Remove row selected
        this.richiestaTableSelectedItem = []

        if (response && response["error"] == null) {
          Util.showPdf(response)
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + JSON.stringify(response.error.Stack))
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      }
    )
  }

}
